import { Box, Button, Drawer, MenuItem, Select, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AccessController from "_shared/AccessController";
import TopBar from "_shared/Top";
import axios from "axios";
import { DashGridL2 } from "layouts/dash-grid";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fetchOfficersList } from "slices/officers";
import { v4 } from "uuid";
import Category from "./Category";
import ConfigureTime from "./ConfigureTime";
import ConfigureTicket from "./ConfigureTicket";
import TicketPopup from "./TicketPopup";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import exportExcel from './generateExcel'



const Main = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { user } = useSelector((state) => state.user);
  const { officers } = useSelector((state) => state.officers);
  const [pageSize, setPageSize] = useState(10);
  // console.log({ OFF: officers });

  const [data, setData] = useState([]);
  const [preData, setPreData] = useState([]);
  // const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false)

  const [category, setCategory] = useState(false)
  const [tickets, setTickets] = useState(true)
  const [configuretime, setConfigureTime] = useState(false)
  const [configuretickets, setConfigureTickets] = useState(false)
  const [popupData, setPopupData] = useState(null)
  const [status, setstatus] = useState(null)
const [filterCategory, setfilterCategory] = useState(null)
const [listCategory, setlistCategory] = useState([])
const [startDate, setStartDate] = useState(null)
const [endDate, setEndDate] = useState(null)
const [search, setsearch] = useState(null)

  const toggleModal = () => setOpen(!open)


  useEffect(() => {
    if (!preData) return;
var serialno=1;
    const _rData = preData.map((columnData) => ({
      id: v4(),
      _id:columnData._id,
      SL_NO:serialno++,
      TICKET_ID: columnData.ticketNo,
      NAME:columnData.user.name,
    //   CITY: "-",
      CATEGORY: columnData.category ? columnData.category : "-",
      SUB_CATEGORY: columnData.subCategory ? columnData.subCategory : "-",
      SUBJECT: columnData.subject || 0,
      DATE: columnData.createdAt || 0,
      STATUS: columnData.status || 0,
      DESCRIPTION:columnData.description,
      createdAt:columnData.createdAt,
      updatedAt:columnData.updatedAt,
      ticketEscalationStatus:columnData.ticketEscalationStatus,
      status:columnData.status,
      SAP_ID:columnData.user.SAP_ID,
      name:columnData.user.name,
      phone:columnData.user.phone
    }));

    setData(_rData);
  }, [preData]);

  useEffect(() => {

    let isMounted = true;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          "https://jk-msfa-dev-api.jktyre.co.in/api/v1/query/QuerygetAll?status=ALL",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (isMounted) {
          console.log("Data received:", response.data.queries);
          setPreData(response.data.queries);
          setlistCategory(response.data.queries)
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);



  useEffect(() => {
    // dispatch(fetchQueryData({ paginationModel, search, status, startDate, endDate, category }))
  }, [ search, status, endDate, category])




  const columns = useMemo(
    () => [
      {
        field: "SL_NO",
        headerName: "SL.NO.",
        // width: 150,
        flex: 1,
      },
      {
        field: "TICKET_ID",
        headerName: "TICKET_ID",
        // width: 150,
        flex: 1,
      },
      {
        field: "NAME",
        headerName: "NAME",
        // width: 175,
        flex: 1,
      },
     
      {
        field: "CATEGORY",
        headerName: "CATEGORY",
        // width: 100,
        flex: 1,
      },
      {
        field: "SUB_CATEGORY",
        headerName: "SUB CATEGORY",
        // width: 100,
        flex: 1,
      },
      {
        field: "SUBJECT",
        headerName: "SUBJECT",
        // width: 100,
        flex: 1,
      },
      {
        field: "DATE",
        headerName: "DATE",
        // width: 100,
        flex: 1,
      },
      {
        field: "STATUS",
        headerName: "STATUS",
        // width: 100,
        flex: 1,
      },{
        field: "ACTION",
        headerName: "",
      //   width: 150,
        flex: 1,
        renderCell: ({ row }) => (
            <Button
            sx={{width: 'auto', minWidth: 0, whiteSpace: 'nowrap' ,fontSize:'0.65rem'}}
              onClick={() => {
                setOpen(true)
                setPopupData(row)
               console.log('row data',row);
              }}
              variant='contained'
              color='primary'
              size='small'
            >
              Take Action
            </Button>)
      },
    ],
    []
  );

  const handleStatusChange = (event, newValue) => {
    setstatus(newValue)
  }

  const handleCategoryChange = (event, newValue) => {
    setfilterCategory(newValue)
  }

  const handleDateChange = dates => {
    const [start, end] = dates
    setStartDate(start)
    setEndDate(end)
  }

  const statusOptions = [
    { value: 'OPEN', label: 'Open' },
    { value: 'IN PROGRESS', label: 'In Progress' },
    { value: 'RESOLVED', label: 'Resolved' },
    { value: 'ASSIGNED', label: 'Assign To' }
  ]


  return (
    <div style={{ width: "98%", marginTop: "2.5rem", marginBottom: "2rem" }}>
              <div>
        <p
          style={{
            font: "25px",
            fontWeight: "bolder",
            color: "darkgrey",
          }}
        >
          Help Desk
        </p>
        <div
          style={{
            width: "98%",
            border: "1.5px solid grey",
          }}
        />
      </div>
      <div
        style={{
          width: "98%",
          marginTop: "1.5rem",
          marginBottom:"2rem"
        }}
      >
    

        <Box>
        <Button
            onClick={() => {
           setCategory(false);
           setConfigureTime(false);
           setConfigureTickets(false);
              setTickets(true)
            }}
            variant={tickets ? "contained" : "outlined"}
            sx={{ mr: 5 }}
          >
            TICKETS 
          </Button>
          <Button
            onClick={() => {
              setCategory(true);
           setConfigureTime(false);
           setConfigureTickets(false);
              setTickets(false)
            }}
            variant={category ? "contained" : "outlined"}
          >
            CATEGORY AND USER LIST</Button>
          <Button
            onClick={() => {
           setCategory(false);
           setConfigureTime(true);
           setConfigureTickets(false);
              setTickets(false)
            }}
            variant={configuretime ? "contained" : "outlined"}
            sx={{ ml: 5 }}
          >CONFIGURE TIME</Button>
          <Button
            onClick={() => {
               setCategory(false);
               setConfigureTime(false);
               setConfigureTickets(true);
              setTickets(false)
            }}
            variant={configuretickets ? "contained" : "outlined"}
            sx={{ ml: 5 }}
          >CONFIGURE TICKETS</Button>
          
        </Box>
      </div>
      {
        tickets?
        <Box>
  
  
  <Select
    labelId="demo-simple-select-label"
    id="demo-simple-select"
    sx={{width:200}}
    value={status}
    label="Age"
    onChange={handleStatusChange}
  >

{statusOptions.map((d) => (
    <MenuItem key={d} value={d.value}>
      {d.label}
    </MenuItem>
  ))}
  </Select>
  

  <Select
    labelId="demo-simple-select-label"
    id="demo-simple-select"
    sx={{width:200,ml:6}}
    value={status}
    label=""
    onChange={handleStatusChange}
  >
    {listCategory.map((d) => (
    <MenuItem key={d} value={d.category
    }>
      {d.category
      }
    </MenuItem>
  ))}
  </Select>
    


  <TextField
  sx={{ml:6}}
          id="filled-search"
          label="Search field"
          type="search"
          variant="filled"
        />

<Button
          sx={{ml:6,height:50}}
          variant='contained'
          color='primary'
          onClick={() => {
            let report = data.map(item => {
              return {
                status: item?.status || 'Unknown',
                userName: item?.NAME || 'Unknown',
                subject: item?.SUBJECT || 'Unknown',
                category: item?.CATEGORY || 'Unknown',
                subCategory: item?.SUB_CATEGORY || 'Unknown',
                description: item?.DESCRIPTION || 'Unknown',
                ticketNo: item?.TICKET_ID || 'Unknown',
                ticketEscalationStatus: item?.ticketEscalationStatus || 'Unknown'
              }
            })
            exportExcel(report, 'details')
          }}
        >
          Download Report
        </Button>
  
  </Box>:<></>
      }
      {
        tickets?
        <DataGrid
          rows={data}
          columns={columns}
          autoHeight={true}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          className="TableCell"
          rowsPerPageOptions={[10, 25, 50, 100]}
          sx={{ fontSize: "0.75rem",mt:4 }}
        />:category?<Category/>:configuretime?<ConfigureTime/>:configuretickets?<ConfigureTicket/>:<div></div>
      }
      {tickets?
      <Drawer
        open={open}
        anchor='right'
        variant='temporary'
        onClose={toggleModal}
        sx={{ '& .MuiDrawer-paper': { width: [500, 550] } }}
      >
        <TicketPopup toggle={toggleModal} popupData={popupData} />
      </Drawer>
      :<></>
      }
    </div>
  );
};

const DealerHelpDesk = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
<DashGridL2 Top={TopBar} Main={Main} />
     
    </AccessController>
  );
};

export default DealerHelpDesk;
